module.exports = __webpack_public_path__ + "img/selected2-min.cf4978ee.png";